<button
  mat-button
  #helpMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="helpMenu"
  class="phone-button"
  data-testid="header-help-button"
  aria-label="Help"
  tabIndex="0">
  <span class="help-button">
    {{ showPhoneNumber ? "Help" : "" }}
    <img src="assets/icons/phone_in_talk-icon.svg" alt="Help">
  </span>
</button>
<mat-menu #helpMenu="matMenu" class="header-menu help-menu">
  <a
    mat-menu-item
    class="header-menu-item help-menu__item"
    [href]="telHref(techSupportNumber)"
    data-testid="help-tech-support-number"
    rel="noopener">
    <img src="assets/icons/phone_in_talk-icon.svg" alt="Phone">
    <span class="help-menu__details">
      <span class="help-menu__number">{{ techSupportNumber }}</span>
      <span class="help-menu__label" data-testid="help-tech-assistance-title">Technology Assistance</span>
      <span class="help-menu__hours">Mon-Fri 8:30 am - 9 pm ET<br />Sat 9 am - 5 pm ET</span>
    </span>
  </a>
  <a
    mat-menu-item
    class="header-menu-item help-menu__item"
    [href]="telHref(documentAndLoanNumber)"
    data-testid="help-doc-loan-number"
    rel="noopener">
    <img src="assets/icons/phone_in_talk-icon.svg" alt="Phone">
    <span class="help-menu__details">
      <span class="help-menu__number">{{ documentAndLoanNumber }}</span>
      <span class="help-menu__label" data-testid="help-doc-loan-title">Document &amp; Loan Concerns</span>
      <span class="help-menu__hours" data-testid="help-doc-loan-hours">Mon-Fri 8 am - 9 pm ET<br />Sat 9 am - 4 pm ET</span>
    </span>
  </a>
</mat-menu>
